var _line, _path, _path2, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrev(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 64.8252,
    y1: 38.6928,
    x2: 15.1744,
    y2: 38.6928,
    stroke: "white",
    strokeWidth: 3.81929
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4247 38.6926C34.7573 48.3682 39.3405 56.7282 39.3405 59.6987",
    stroke: "white",
    strokeWidth: 3.81929
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4247 38.6924C34.7573 32.0723 39.3405 23.6274 39.3405 20.2325",
    stroke: "white",
    strokeWidth: 3.81929
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 77.4709,
    y: 77.4025,
    width: 74.9418,
    height: 74.8734,
    rx: 37.4367,
    transform: "rotate(-180 77.4709 77.4025)",
    stroke: "white",
    strokeWidth: 5.05821
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrev);
export default __webpack_public_path__ + "static/media/prev.428a2433270c1fbc05dc4d4374c94916.svg";
export { ForwardRef as ReactComponent };